import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';

import { selectUser } from 'redux/user/selectors';
import { forgotPassword, logIn } from 'redux/user/actions';
import { hideHeader, setAppLoader, setThemeName } from 'redux/uiEffects/actions';

import LoginContainer from 'containers/CabinetContainers/LoginContainer';

function UserManager() {
    const dispatch = useDispatch();
    const [isForgotPassword, setIsForgotPassword] = useState(false);

    useEffect(() => {
        dispatch(setAppLoader(false));
        dispatch(hideHeader(true));
        dispatch(setThemeName('green'));
    }, []);

    const { token, isLoading } = useSelector(selectUser);

    useEffect(() => {
        if (token) {
            window.location.href = '/main';
        }
    }, [token]);

    const handleLogIn = ({ email, password, onFail }: { email: string; password: string; onFail: () => void }) => {
        dispatch(logIn({ payload: { email, password }, setError: () => onFail() }));
    };

    const handleForgotPassword = ({ email, onFail }: { email: string; onFail: () => void }) => {
        dispatch(
            forgotPassword({
                payload: { email },
                setError: () => onFail(),
                onSuccess: () => setIsForgotPassword(false),
            })
        );
    };

    return (
        <LoginContainer
            isForgotPassword={isForgotPassword}
            setIsForgetPasswordForm={() => setIsForgotPassword((prev) => !prev)}
            isLoading={isLoading}
            onSubmit={isForgotPassword ? handleForgotPassword : handleLogIn}
        />
    );
}

export default UserManager;
